import React from 'react'
import PropTypes from 'prop-types'
import {DrawerAppContent as RmwcDrawerAppContent} from '@rmwc/drawer'
import '@rmwc/drawer/styles'

const DrawerAppContent = ({children, ...otherProps}) => <RmwcDrawerAppContent {...otherProps}>{children}</RmwcDrawerAppContent>

DrawerAppContent.propTypes = {
  children: PropTypes.any
}

export {DrawerAppContent}
